<script setup>
import { ref, onMounted } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";
import '@splidejs/vue-splide/css';
import BaseIcon from "@/Components/BaseIcon.vue";
import helpers from '../Common/helpers';
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiHandshakeOutline,
    mdiAccountGroupOutline,
    mdiShieldStarOutline,
    mdiTruckDeliveryOutline,
    mdiTrashCan,
    mdiCart,
    mdiStarOutline,
    mdiSend,
    mdiArrowULeftTopBold,
    mdiContentSave

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    brands: Object,
    //connstantes: Array

})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)


// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcas = ref(null)
marcas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]


// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

onMounted(() => {
    getCart()
});

const enablecot = ref(0)
const products = ref([])
const prodscart = ref([])
const prodscartcant = ref([])
const getData = (ids = []) => {
    let url = '/ecommerce/getproductscart';

    let params = {
        'ids': ids
    }

    //loading.value = true;
    axios.post(url, params).then((response) => {
        products.value = response.data;
        console.log('filter order ok');
    }).catch((error) => {
        console.log(error);
    });
    //loading.value = false;
}

const qtyCart = ref(0)
const getCart = () => {
    let cart = []
    let newArr = []
    //let cartStorage = localStorage.getItem('cart')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
        prodscart.value = cart;
        cart.forEach((prod) => {
            newArr.push(prod.id)
            prodscartcant.value[prod.id] = prod.cant
        })
        getData(newArr)
    }
    return cart
}

const addCart = (prodid = 0, cant = 1, ref = '', label = '', price = '') => {
    let cart = getCart()
    let newObj = { 'id': prodid, 'cant': cant, 'ref': ref, 'label': label, 'price': price }
    if (cart && cart.length > 0) {
        let obj = cart.find(o => o.id === prodid)
        if (obj !== undefined && obj !== null) {
            obj.cant = cant
        } else {
            cart.push(newObj)
        }
        sessionStorage.setItem('cart', JSON.stringify(cart))
        qtyCart.value = cart.length
        console.log('Upd Cart')
    } else {
        let newCart = [newObj]
        //localStorage.setItem('cart', JSON.stringify(newCart))
        sessionStorage.setItem('cart', JSON.stringify(newCart))
        qtyCart.value = newCart.length
        console.log('New Cart')
    }
    getCart()
    //emit('reload')

}

const delCart = (prodid = 0) => {
    let valid = confirm('Seguro de eliminar este item?')
    if (valid) {
        let cart = getCart()
        if (cart && cart.length > 0) {
            let index = cart.findIndex(o => o.id === prodid)
            cart.splice(index, 1)

            sessionStorage.setItem('cart', JSON.stringify(cart))
            qtyCart.value = cart.length
            console.log('Del Cart')

        }
        //emit('reload')
        //window.location.reload()
        //enablecot.value = 0
        //getCart()
        let button = document.getElementById('button-carrito');
        button.click();
    }

}

const removeCart = () => {
    let valid = confirm('Seguro de vaciar el carrito?')
    if (valid) {
        sessionStorage.removeItem('cart')
        qtyCart.value = 0
        console.log('Del All Cart')
        //getCart()
        let button = document.getElementById('button-seguir-comprando');
        button.click();
    }

}

</script>

<!-- <script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});

</script> -->



<template>
    <SeoMeta />
    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent" :qtyCart="qtyCart">


        <!-- Modal -->
        <CardBoxModal v-model="isModalActive" title="Matrícula en línea">
            <p>Información del <b>padre de familia / apoderado</b></p>
            <!--<p>This is sample modal</p>-->
            <div>
                <BreezeLabel for="nombre" value="Nombre" />
                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.nombre" required autofocus autocomplete="name" />
            </div>
            <div class="mt-4">
                <BreezeLabel for="nivel" value="Nivel escolar" />
                <BreezeInput id="inicial" type="checkbox" class="mt-1 ml-2" v-model="form.inicial" required autocomplete="inicial" /> Inicial
                <BreezeInput id="primaria" type="checkbox" class="mt-1 ml-2" v-model="form.primaria" required autocomplete="primaria" /> Primaria
                <BreezeInput id="secundaria" type="checkbox" class="mt-1 ml-2" v-model="form.secundaria" required autocomplete="secundaria" /> Secundaria
            </div>
            <div class="mt-4">
                <BreezeLabel for="phone" value="Teléfono" />
                <BreezeInput id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" required autocomplete="phone" />
            </div>
            <div class="mt-4">
                <BreezeLabel for="email" value="Email" />
                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="mail" />
            </div>

            <div class="mt-4">
                <BreezeLabel for="comment" value="Comentario" />
                <BreezeInput id="comment" type="text" class="mt-1 block w-full" v-model="form.comment" required autocomplete="comment" />
            </div>
            <!--<div class="block mt-4">
                <label class="flex items-center">
                    <BreezeCheckbox name="remember" v-model:checked="form.recibirinfo" />
                    <span class="ml-2 text-sm text-gray-600">Recibir novedades?</span>
                </label>
            </div>-->
        </CardBoxModal>



        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/informacion/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Tu Carrito</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Compra de Productos</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->

        <section>
            <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                <div class="grid grid-cols-1 gap-4">
                    <div class="col-span-1">
                        <h1 class="text-2xl lg:text-3xl font-bold mb-4 ">Mi Carrito</h1>
                    </div>

                    <div>
                        <div class="pb-4">
                            <p class="text-sm text-gray-800">A continuación puede visualizar un resumen de los productos seleccionados para adquirir</p>
                        </div>
                        <div class="relative overflow-x-auto shadow-xl shadow-gray-400/10 sm:rounded-lg mb-6">
                            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-center">
                                            SKU
                                        </th>
                                        <th scope="col" class="px-6 py-3">
                                            Nombre del Producto
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center">
                                            Precio
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center">
                                            Cantidad
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center">
                                            Total
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center">

                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="products.length > 0">
                                    <tr v-for="(item, index) in products" :key="item.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {{ item.ref }}
                                        </td>
                                        <td class="px-6 py-4">
                                            <Link :href="route('eco-product-show', { id: item.id })">
                                            <div class="flex space-x-6 items-center">
                                                <div class="w-[80px] h-[80px] overflow-hidden flex justify-center items-center border border-[#EDEDED]"><img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" alt="product" class="w-full h-full object-contain"></div>
                                                <div class="flex-1 flex flex-col">
                                                    <p class="font-medium text-sm text-qblack">{{ item.label }}</p>
                                                    <small class="text-sm text-blue-800">Stock: {{ item.stock }}</small>
                                                    <small v-if="item.stockable_product == 2" class="text-sm text-blue-800">* A pedido</small>
                                                </div>
                                            </div>
                                            </Link>
                                        </td>
                                        <td class="px-6 py-4 text-center">
                                            <div class="w-40 min-w-40">
                                                {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.price_ttc }}
                                            </div>
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex justify-center items-center">
                                                <div class="relative w-36">
                                                    <button class="absolute h-8 w-8 left-1 top-1 my-auto p-1 flex items-center btn-color rounded hover:bg-blue-800" type="button" @click="(prodscartcant[item.id] -= 1)">
                                                        <BaseIcon :path="mdiMinus" :size="20" class="text-white" w="w-6" h="h-6"></BaseIcon>
                                                    </button>
                                                    <input type="number" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none pl-4 h-10 p-2 text-sm border-gray-200 text-center hover:border-gray-200 focus:border-blue-300 bg-transparent font-semibold w-full focus:ring-4 focus:ring-blue-300/50 transition-transform ease-out duration-300" v-model="prodscartcant[item.id]" />
                                                    <button class="absolute h-8 w-8 right-1 top-1 my-auto p-1 flex items-center btn-color rounded hover:bg-blue-800" type="button" @click="(prodscartcant[item.id] += 1)">
                                                        <BaseIcon :path="mdiPlus" :size="20" class="text-white" w="w-6" h="h-6"></BaseIcon>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 text-center w-40 min-w-40">
                                            <div class="w-40 min-w-40">
                                                {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.price_ttc * prodscartcant[item.id] }}
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 text-center" :set="((item.stockable_product == 2 || item.stock == 0) ? enablecot = 1 : '')">
                                            <div class="space-x-2 w-20 min-w-20">
                                                <BaseButton color="success" :icon="mdiContentSave" @click="addCart(item.id, prodscartcant[item.id])" />
                                                <BaseButton color="danger" :icon="mdiTrashCan" @click="delCart(item.id)" />
                                            </div>

                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <div v-if="enablecot" class="pb-4">
                            <p class="text-sm text-blue-800">* Existen productos <b>A pedido</b> o en <b>stock cero</b> en su carrito, así que el modo de envío será cotización</p>
                        </div>
                        <div v-if="products.length > 0" class="flex flex-col sm:flex-row item-start lg:items-center justify-end gap-4">
                            <div>
                                <Link href="/">
                                <BaseButton id="button-seguir-comprando" :icon="mdiArrowULeftTopBold" small label="Seguir Comprando" class="btn btn-color px-8" />
                                </Link>
                            </div>

                            <div>
                                <Link :href="route('eco-infoaddress', { cot: enablecot })">
                                <BaseButton :icon="mdiSend" small :label="(enablecot ? 'Solicitar cotización' : 'Solicitar Pedido')" class="btn btn-color px-8" />
                                </Link>
                            </div>
                            <div>

                                <BaseButton color="danger" :icon="mdiTrashCan" small label="vaciar el carrito" class="btn px-8" @click="removeCart()" />

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->


        <!--START MARCAS -->
        <!--START MARCAS -->
        <!--START MARCAS -->

        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Marcas que ofrecemos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-brands')">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block hover:text-color text-gray-900">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="relative slider-marcas slider-marcas-color" v-if="brands.length > 0">
                    <hr class="my-4">
                   <Splide :has-track="true" :options="{ rewind: 'true', perMove: 1, type: 'loop', autoplay: true, pagination: false, arrows: true, gap: '1em', mediaQuery: 'min', breakpoints: { 1820: { perPage: 7 }, 1536: { perPage: 6 }, 1023: { perPage: 4 }, 640: { perPage: 2 }, 0: { perPage: 1 } } }" class="rounded-md" id="">
                        <SplideSlide class="rounded-md w-full h-full " v-for="(item, index) in brands" :key="item.id">
                            <div class="w-full h-[110px] lg:h-[150px] marca" :title="item.label">
                                    <Link :href="route('eco-product-category', { id: 0, label: '', originbrand: item.id })" class="">
                                        <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="hover:grayscale h-14 xl:h-20 !object-contain transition-all ease-in-out duration-500">
                                    </Link>
                              
                            </div>
                        </SplideSlide>
                    </Splide>
                    <hr class="my-4">
                </div>
            </div>
        </section>
        <!-- END MARCAS -->
        <!-- END MARCAS -->
        <!-- END MARCAS -->




        <!-- <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
